import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GenerateAssertion($provider: GenerateAssertionProvider, $metadata: GenerateAssertionMetadata) {
    generateAssertion(provider: $provider, metadata: $metadata) {
      response
      acs
    }
  }
`
export const generateAssertionKey = getQueryNames(query)[0]

export default query
